const toNumber = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};


const buildPayload = (location) => {
  return {
    lat: toNumber(location?.coords?.latitude ?? location?.latitude ?? location?.lat),
    lng: toNumber(location?.coords?.longitude ?? location?.longitude ?? location?.lng),
    speed: toNumber(location?.coords?.speed ?? location?.speed),
  };
};

const sendLiveLocation = async (api, location) => {
  const payload = buildPayload(location);

  try {
    await api.post('/api/app/v1/shipito/live-location', payload);
  } catch (error) {
    console.error('Error sending live location:', error.message || error);
  }
};

export default sendLiveLocation;
